const Constants = {
	CLIENT_NAMES: {
		BASIC: "com.simulationcurriculum.SkySafari6",
		BASIC_7: "com.simulationcurriculum.SkySafari7",
		PLUS: "com.simulationcurriculum.SkySafari6Plus",
		PLUS_7: "com.simulationcurriculum.SkySafari7Plus",
		PLUS_8: "com.simulationcurriculum.SkySafari8Plus",
		PLUS_8_IOS: "com.simulationcurriculum.SkySafari8Plus.iOS",
		PRO: "com.simulationcurriculum.SkySafari6Pro",
		PRO_7: "com.simulationcurriculum.SkySafari7Pro",
		PRO_8: "com.simulationcurriculum.SkySafari8Pro",
		PRO_8_IOS: "com.simulationcurriculum.SkySafari8Pro.iOS",
		MAC_PLUS: "com.simulationcurriculum.SkySafari6MacPlus",
		MAC_PLUS_7: "com.simulationcurriculum.SkySafari7MacPlus",
		MAC_PLUS_8: "com.simulationcurriculum.SkySafari8MacPlus",
		MAC_PRO: "com.simulationcurriculum.SkySafari6MacPro",
		MAC_PRO_7: "com.simulationcurriculum.SkySafari7MacPro",
		MAC_PRO_8: "com.simulationcurriculum.SkySafari8MacPro",
		// There was a bug in the android version on release that included a trailing dot
		ANDROID_PLUS_DOT: "com.simulationcurriculum.skysafari6plus.android.",
		ANDROID_PLUS_7: "com.simulationcurriculum.skysafari7plus.android",
		ANDROID_PLUS_8: "com.simulationcurriculum.skysafari8plus.android",
		ANDROID_PRO_DOT: "com.simulationcurriculum.skysafari6pro.android.",
		ANDROID_PRO_7: "com.simulationcurriculum.skysafari7pro.android",
		ANDROID_PRO_8: "com.simulationcurriculum.skysafari8pro.android",
		ANDROID_BASIC: "com.simulationcurriculum.skysafari5", // We just updated the SS 5 APP!
		ANDROID_PLUS: "com.simulationcurriculum.skysafari6plus.android",
		ANDROID_PRO: "com.simulationcurriculum.skysafari6pro.android",
		STELLA_ACCESS_IOS: "com.meade.StellaAccess",
		STELLA_ACCESS_ANDROID: "com.meade.stellaaccess",
		SKYPORTAL_IOS: "com.celestron.skyportal",
		SKYPORTAL_ANDROID: "com.celestron.skyportal",
		SN_PROPLUS_MAC: "com.simulationcurriculum.starrynight.proplus.8.osx",
		SN_PROPLUS_WIN: "com.simulationcurriculum.starrynight.proplus.8.win32",
		SN_PRO_MAC: "com.simulationcurriculum.starrynight.pro.8.osx",
		SN_PRO_WIN: "com.simulationcurriculum.starrynight.pro.8.win32",
		SN_ENTHUSIAST_MAC: "com.simulationcurriculum.starrynight.enthusiast.8.osx",
		SN_ENTHUSIAST_WIN:
			"com.simulationcurriculum.starrynight.enthusiast.8.win32",
		SN_CSAP_MAC: "com.simulationcurriculum.starrynight.csap.8.osx",
		SN_CSAP_WIN: "com.simulationcurriculum.starrynight.csap.8.win32",
	},

	MODAL_CONTAINER_SELECTOR: "#modalContainer",
};

const proClients = [
	"com.simulationcurriculum.SkySafari6Pro",
	"com.simulationcurriculum.SkySafari7Pro",
	"com.simulationcurriculum.SkySafari8Pro",
	"com.simulationcurriculum.SkySafari8Pro.iOS",
	"com.simulationcurriculum.SkySafari6MacPro",
	"com.simulationcurriculum.SkySafari7MacPro",
	"com.simulationcurriculum.SkySafari8MacPro",
	"com.simulationcurriculum.skysafari6pro.android.",
	"com.simulationcurriculum.skysafari7pro.android",
	"com.simulationcurriculum.skysafari8pro.android",
	"com.simulationcurriculum.skysafari6pro.android",
	"com.simulationcurriculum.starrynight.proplus.8.osx",
	"com.simulationcurriculum.starrynight.proplus.8.win32",
	"com.simulationcurriculum.starrynight.pro.8.osx",
	"com.simulationcurriculum.starrynight.pro.8.win32",
];

const plusClients = [
	"com.simulationcurriculum.SkySafari6Plus",
	"com.simulationcurriculum.SkySafari7Plus",
	"com.simulationcurriculum.SkySafari8Plus",
	"com.simulationcurriculum.SkySafari8Plus.iOS",
	"com.simulationcurriculum.SkySafari6MacPlus",
	"com.simulationcurriculum.SkySafari7MacPlus",
	"com.simulationcurriculum.SkySafari8MacPlus",
	"com.simulationcurriculum.skysafari6plus.android.",
	"com.simulationcurriculum.skysafari7plus.android",
	"com.simulationcurriculum.skysafari8plus.android",
	"com.simulationcurriculum.skysafari6plus.android",
	"com.meade.StellaAccess",
	"com.meade.stellaaccess",
	"com.simulationcurriculum.starrynight.enthusiast.8.osx",
	"com.simulationcurriculum.starrynight.enthusiast.8.win32",
];

Constants.HasProOrPlusFeatures = (clientApps) => {
	const proAndPlusClients = [...proClients, ...plusClients];

	return clientApps.some((item) => proAndPlusClients.includes(item));
};

Constants.HasProFeatures = (clientApps) => {
	clientApps = clientApps || [];
	if (
		clientApps.indexOf(Constants.CLIENT_NAMES.PRO) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.PRO_7) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.PRO_8) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.PRO_8_IOS) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.MAC_PRO) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.MAC_PRO_7) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.MAC_PRO_8) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.ANDROID_PRO_DOT) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.ANDROID_PRO_7) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.ANDROID_PRO_8) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.ANDROID_PRO) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.SN_PROPLUS_MAC) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.SN_PROPLUS_WIN) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.SN_PRO_MAC) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.SN_PRO_WIN) > -1
	) {
		return true;
	}

	return false;
};

Constants.HasPlusFeatures = (clientApps) => {
	clientApps = clientApps || [];
	if (
		clientApps.indexOf(Constants.CLIENT_NAMES.PLUS) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.PLUS_7) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.PLUS_8) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.PLUS_8_IOS) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.MAC_PLUS) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.MAC_PLUS_7) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.MAC_PLUS_8) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.ANDROID_PLUS_DOT) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.ANDROID_PLUS_7) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.ANDROID_PLUS_8) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.ANDROID_PLUS) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.STELLA_ACCESS_IOS) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.STELLA_ACCESS_ANDROID) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.SN_ENTHUSIAST_MAC) > -1 ||
		clientApps.indexOf(Constants.CLIENT_NAMES.SN_ENTHUSIAST_WIN) > -1
	) {
		return true;
	}

	return false;
};

export default Constants;
